function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useAction } from 'hooks';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const InstallingBlueCableDrivers = ({ onSetComponent })=>{
    const { driver } = useSelector(selectors.downloader);
    const installBlueCableDriver = useAction(actions.installBlueCableDriver);
    useEffect(()=>{
        const installationState = get(driver, 'installationState', 'NotStarted');
        installBlueCableDriver(installationState);
    }, []);
    useEffect(()=>{
        const { isDriverInstalled, installationState } = driver;
        if (isDriverInstalled) {
            onSetComponent('InstalledBlueCableDrivers');
        } else if (installationState === 'CompletedWithError') {
            onSetComponent('NoConnection');
        }
    }, [
        driver
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.installingBlueCableDrivers.header))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.installingBlueCableDrivers.info))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/loader.svg",
                    className: "rotatingLoader",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info text--center mb-5",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.installingBlueCableDrivers.waiting))
            })
        ]
    });
};
export default InstallingBlueCableDrivers;
